import { LogoRedRocketCircle, Modal } from '@lessonup/typescript-core/ui';
import React from 'react';
import { Translation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle -- auto-generated TECH-258
import { AppServicesConsumer } from '../appServices/AppServicesContext';
import './LessonsSyncedModal.less';

export interface SavedLesson {
  lessonName?: string;
  lessonId: string;
}

export interface LessonSyncedModalResult {
  status: 'success' | 'failed';
  data: {
    lesson?: SavedLesson[];
  };
}

const TRANSLATION_NAMESPACE = 'savemodal';

type Props = {
  closeModal: (result: LessonSyncedModalResult | undefined) => void;
};

export class LessonsSyncedModal extends React.Component<Props> {
  public constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
  }

  public handleClose() {
    this.props.closeModal(undefined);
  }

  public render() {
    return (
      <AppServicesConsumer
        // eslint-disable-next-line @typescript-eslint/no-unused-vars -- auto-generated TECH-258
        render={(services) => {
          return (
            <Translation>
              {(t) => {
                return (
                  <Modal title={t('title', { ns: TRANSLATION_NAMESPACE })} isOpen onRequestClose={this.handleClose}>
                    <div className="savemodal__header">
                      <div className="savemodal_headertext">{t('did-save-lessons', { ns: TRANSLATION_NAMESPACE })}</div>
                      <LogoRedRocketCircle className="savemodal__logo logo-red-rocket-circle" />
                    </div>

                    <div>{t('find-in-lessonup', { ns: TRANSLATION_NAMESPACE })}</div>
                  </Modal>
                );
              }}
            </Translation>
          );
        }}
      />
    );
  }
}
